(() => {
    function updatePalette(section, variantId) {
        if (String(window.productJson?.id) !== section.dataset.productId) return;
        const variant = window.productJson.variants?.find((item) => String(item.id) === String(variantId));
        const palette = variant?.palette;
        if (!palette) return;
        section.style.setProperty('--product-color', palette.highlight_color);
        section.style.setProperty('--pdp-v12-text-color', palette.black_text ? 'var(--black)' : 'var(--off-white)');
        section.style.setProperty('--pdp-v12-link-color', palette.black_text ? 'var(--black)' : palette.highlight_color);
        section.style.setProperty('--pdp-v12-icon-filter', palette.black_text ? 'brightness(0)' : 'brightness(0) invert(1)');
    }

    function initializeNutrition(section) {
        const slider = section.querySelector('[data-v12-active] .info.swiper');
        if (!slider || typeof Swiper === 'undefined') return;
        const count = Number(section.querySelector('[data-info-count]')?.dataset.infoCount);
        const swiper = new Swiper(slider, {
            slidesPerView: 1.05,
            centeredSlides: true,
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: section.querySelector('.infoNext'),
                prevEl: section.querySelector('.infoPrev')
            },
            on: {
                slideChange() {
                    section.querySelectorAll('.infoPagBtn').forEach((button, index) => {
                        button.classList.toggle('active', index === this.realIndex % count);
                    });
                }
            }
        });
        section.querySelectorAll('.infoPagBtn').forEach((button) => {
            button.addEventListener('click', () => swiper.slideToLoop(Number(button.dataset.target) - 1));
        });
    }

    function update(section, variantId) {
        // Apply palette even when the nutrition content is unchanged.
        updatePalette(section, variantId);
        const template = section.querySelector(`template[data-v12-variant="${variantId}"]`)
            || section.querySelector('template[data-v12-default]');
        const target = section.querySelector('[data-v12-active]');
        if (!template || !target || section.dataset.activeVariant === String(variantId)) return;
        target.querySelector('.info.swiper')?.swiper?.destroy(true, true);
        target.replaceChildren(template.content.cloneNode(true));
        section.dataset.activeVariant = String(variantId);
        initializeNutrition(section);
    }

    function initialize(root = document) {
        root.querySelectorAll('[data-v12-main]').forEach((section) => {
            const variantId = section.querySelector('form [name="id"]')?.value;
            if (variantId) updatePalette(section, variantId);
        });
        root.querySelectorAll('[data-v12-content]').forEach((section) => {
            if (section.dataset.v12Initialized) return;
            section.dataset.v12Initialized = 'true';
            initializeNutrition(section);
            // Main-product may have already selected a variant before this listener starts.
            const main = document.querySelector(`[data-v12-main][data-product-id="${section.dataset.productId}"]`);
            const variantId = main?.querySelector('form [name="id"]')?.value
                || new URLSearchParams(location.search).get('variant');
            if (variantId) update(section, variantId);
        });
    }

    document.addEventListener('variant:changed', (event) => {
        const variant = event.detail?.variant;
        if (!variant?.id) return;
        document.querySelectorAll('[data-v12-main]').forEach((section) => updatePalette(section, variant.id));
        document.querySelectorAll('[data-v12-content]').forEach((section) => {
            if (section.querySelector(`template[data-v12-variant="${variant.id}"]`)
                || window.productJson?.variants?.some((item) => String(item.id) === String(variant.id))) {
                update(section, variant.id);
            }
        });
    });
    document.addEventListener('shopify:section:load', () => initialize());
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
})();
